/* hs-eslint ignored failing-rules */

/* eslint-disable hubspot-dev/no-confusing-browser-globals */
'use es6';

if (self !== top && window.newrelic && window.newrelic.setCustomAttribute) {
  console.warn(`Detected HubSpot login being framed from ${document.referrer}. Note that this is not supported and we suggest you look into integrating properly.`);
  window.newrelic.setCustomAttribute('iframeReferrer', document.referrer);
}